export default __webpack_public_path__ + "static/media/chetan.f50bb234.jpg";